import React from 'react';
import { useParams } from 'react-router-dom';

// Ícones por atividade do BPO RH (mesmos do sidebar)
const ICONE_ATIVIDADE_DP = {
  'Admissões': 'fa-user-plus',
  'Rescisões': 'fa-user-minus',
  'Férias': 'fa-umbrella-beach',
  'Folha de Pagamento': 'fa-file-invoice-dollar',
  'Prorrogação Colaborador': 'fa-user-clock',
  'Exame Mensal': 'fa-notes-medical',
};

// Página de trabalho de cada atividade do BPO RH (/Dp/:atividade).
// Estrutura base — o fluxo de tarefas de cada atividade será construído aqui.
const DpAtividade = () => {
  const { atividade } = useParams();
  const nomeAtividade = atividade ? decodeURIComponent(atividade) : '';
  const icone = ICONE_ATIVIDADE_DP[nomeAtividade] || 'fa-folder-open';

  return (
    <div className="dp-atividade-page">
      <div className="container-fluid mt-4 shadow p-4 rounded bg-white">
        {/* Cabeçalho */}
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <i className={`fas ${icone} header-icon me-2`}></i>
            <h2 className="titulo-pagina m-0">BPO RH — {nomeAtividade}</h2>
          </div>
        </div>

        <div className="alert alert-info border-start border-info border-3">
          <i className="fas fa-info-circle me-2"></i>
          Página de trabalho de <strong>{nomeAtividade}</strong>. O fluxo de tarefas desta
          atividade será construído aqui.
        </div>
      </div>
    </div>
  );
};

export default DpAtividade;
